<template>
  <div id="app">
    <app-header v-show="header_show"></app-header>
    <router-view v-on:header="header" v-on:footer="footer"></router-view>
    <app-footer v-show="footer_show"></app-footer>
  </div>
</template>

<script>
import Header from "./components/header";
import Footer from "./components/footer";
export default {
  name: "App",
  data() {
      localStorage.setItem("num", 0);
    return {
      header_show: true,
      footer_show: true
    };
  },
  components: {
    "app-header": Header,
    "app-footer": Footer
  },
  methods: {
    //是否显示头部
    header: function(bool) {
      this.header_show = bool;
    },
    //是否显示底部
    footer: function(bool) {
      this.footer_show = bool;
    }
  }
};
</script>

<style>
  body {
  padding-right: 0 !important;
  min-width: 1200px;
}
body::-webkit-scrollbar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue